import dynamic from 'next/dynamic'
import { analytics } from '@helpers/analytics'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from '../styles.module.scss'
import modalstyles from './chestSizeModal.module.scss'

const Modal = dynamic(() => import('@components/ui/Modal'))

const CHEST_SIZE_TABLE_DATA = {
  thead: [{ defaultValue: 'Spoke Top Size', value: 'Chest Size' }],
  tbody: [
    { defaultValue: 'S', value: '36' },
    { defaultValue: 'M', value: '38' },
    { defaultValue: 'M+', value: '39' },
    { defaultValue: 'L', value: '40' },
    { defaultValue: 'L+', value: '41' },
    { defaultValue: 'XL', value: '42' },
    { defaultValue: 'XXL', value: '44' }
  ]
} as const

type ChestSizeSubtitleWithModalProps = {
  modalOpen: boolean
  toggleModal: () => void
}

function ChestSizeSubtitleWithModal({
  modalOpen,
  toggleModal
}: ChestSizeSubtitleWithModalProps) {
  const data = {
    table: CHEST_SIZE_TABLE_DATA,
    byline:
      'The Jack is cut in traditional tailoring chest sizes — 36″ through to 44″. Consult this canny chart to see how this corresponds with our standard top sizes.',
    title: 'What’s my chest size?'
  }

  const handleOpenModal = () => {
    toggleModal()
    analytics('Click', {
      label: data.title
    })
  }

  return (
    <>
      <div className={styles.subtitle__container}>
        <h2 className={styles.subtitle}>Chest Size</h2>
        <div className={styles.subtitle}>
          <ButtonMinimal underlined onClick={handleOpenModal}>
            {data.title}
          </ButtonMinimal>
        </div>
      </div>
      {modalOpen && (
        <Modal
          onClose={toggleModal}
          openedModal={modalOpen}
          classes={modalstyles.ChestSizeModalWrapper}
        >
          <h2>{data.title}</h2>
          <p className={styles.subtitle}>{data.byline}</p>
          <table className={modalstyles.ModalTable}>
            <thead>
              {CHEST_SIZE_TABLE_DATA.thead.map(row => (
                <tr>
                  <th>{row.defaultValue}</th>
                  <th>{row.value}</th>
                </tr>
              ))}
            </thead>
            <tbody>
              {CHEST_SIZE_TABLE_DATA.tbody.map(row => (
                <tr>
                  <td className={modalstyles.ModalTable__defaultColumn}>
                    {row.defaultValue}
                  </td>
                  <td>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      )}
    </>
  )
}

export default ChestSizeSubtitleWithModal
